import React, { Fragment } from "react";
import HubspotLetsTalkForm from "../hubspot_lets_talk_form";

import { TemplateOfferingConfirmOrderMultiPass } from "../template_offering_confirm_order_multipass";
import { useMindspaceAnalytics } from "./mindspace_analytics";
import { partnerConfig } from "./mindspace_partner_config";
import { lazyWithRetry } from "../../core/lazy_with_retry";

const Theme = lazyWithRetry(() => import("./mindspace_theme"));

export function OfferingMindspaceConfirmOrderMultiPass() {
  useMindspaceAnalytics();

  return (
    <Fragment>
      <Theme />
      <TemplateOfferingConfirmOrderMultiPass
        partnerConfig={{
          ...partnerConfig,
          hubspotForm: (
            <HubspotLetsTalkForm
              portalId="5264364"
              formId="10bed070-52fd-436e-b1c6-3bf15047acc1"
            />
          ),
        }}
      />
    </Fragment>
  );
}
